import React, { useEffect, useState } from 'react'
import { useGlobalContext } from '../Context';
import { useSelector } from 'react-redux';
import apiService from '../../api/ApiService';
import { paginateCount } from '../../api/helper';
import { useLocation } from 'react-router-dom';

const useList = (id) => {
  const [q,setQ]=useState('')

  const {currentTimeDiff}=useSelector(state=>state.p.time)
    const {currentAdmin,currentTheme}=useSelector(state=>state.p.admin)
  const [data,setData]=useState([]);
  const [cycleList,setCycleList]=useState([]);
  const [currentCycle,setCurrentCycle]=useState(null)
  const [statuses,setStatuses]=useState([])
  const [page,setPage]=useState(0);
  const [pens,setPens]=useState([])
  const [hasSensor,setHasSensor]=useState(null);
  const [currentPen,setCurrentPen]=useState('')
  const [currentStatus,setCurrentStatus]=useState(null)
  const [check,setCheck]=useState(false)
  const [total,setTotal]=useState(paginateCount)
  const getData=async()=>{

      const data=JSON.stringify({
        "skip": page?(page-1)*paginateCount:0,
        "take": paginateCount,
        "fromDate": null,
        "toDate": null,
        "penIds":currentPen?[`${currentPen}`]:id?[id]:[],
        "statuses":currentStatus?[`${currentStatus}`]:[],
        "hasSensor":hasSensor==='همه ی دام ها'?null:JSON.parse(hasSensor),
        "lifeCycles":currentCycle?[`${currentCycle}`]:[],
        'number':q?+q:null
      })
     
        const res=await apiService.getAllCattles(data)
        setData(res.data.data)
        setTotal(Math.ceil(res.data.totalCount/paginateCount))
            
    
    }
    const handlePage = (event, value) => {
      setPage(value);
    };
    const getDataPii=async()=>{
      const dat=JSON.stringify({
          "penIds": [],
          "includePen":false,
          "date": currentTimeDiff
        })
      const res=await apiService.getFatmsStatus(dat)
     
      setStatuses(res.data?.statuses)
      setCycleList(res.data?.lifeCycles)
  }
  const getPens=async()=>{
    const data=JSON.stringify({
        "skip": -1,
        "take": -1,
        "fromDate": null,
        "toDate": null,
        "isActive": true
      })
            const res=await apiService.getPens(data)
  
            setPens(res.data.data)
          
    
    }
  useEffect(()=>{
    getDataPii()
    getPens()
  },[]);
  useEffect(()=>{
    getData()
  },[page])
  useEffect(()=>{
  if(check){
    setData('')
    setPage(0)
    getData()
  }else{
    setCheck(true)
  }
  },[hasSensor,currentPen,currentStatus,currentCycle,id])
  useEffect(() => {
    if(check){
      const timeoutId = setTimeout(() => {
      
        getData()
      
    }, 900)
    return () => clearTimeout(timeoutId)
    }else{
      setCheck(true)
    }
  }, [q])
  return {
    page,handlePage,currentCycle,currentStatus,currentPen,data,pens,statuses,cycleList,setHasSensor,setCurrentCycle,setCurrentPen,setCurrentStatus,hasSensor,currentTheme,total,setPage,q,setQ
  }
}

export default useList

